import { http } from "./http";
import type { Project } from "./project.service";

export interface DashboardMetrics {
  projects_total: number;
  projects_active: number;
  ai_runs_30d: number;
  ai_runs_failed_30d: number;
  usage_30d: number;
  deployments_total: number;
}

export interface DeploymentSummary {
  id: string;
  project: string | null;
  environment: string | null;
  status: string;
  created_at: string | null;
}

export interface ErrorSummary {
  id: string;
  project: string | null;
  message: string;
  created_at: string | null;
}

export interface DashboardSummary {
  metrics: DashboardMetrics;
  recent_projects: Project[];
  recent_deployments: DeploymentSummary[];
  recent_errors: ErrorSummary[];
}

export const dashboardService = {
  summary: () => http.get<DashboardSummary>("/dashboard/summary"),
};
